<!-- eslint-disable -->
<template lang="pug">
    cs-modal(@close="$emit('close')")
        template(v-if="!successChanged")
            div(slot="header")
                | {{ $i18n.t('billing.billing_modal_balanceChanging') }}:
            form.balance-modal__form(action="javascript://" @submit="updateBalance")
                .way-selector(v-if="profile.name")
                    .way-selector__buttons(v-if="false")
                        cs-button.cs-button--selector(
                            v-for="way in waysOfChanging",
                            type="button"
                            :key="way",
                            @click.prevent="handleWayChange(way)",
                            :class="{\
                                'cs-button--active-selector': selectedWay === way,\
                            }"
                        )
                            | {{ wayName(way) }}
                    .way-selector__multiselect
                        cs-multiselect(
                            :multiple="false"
                            :options="waysOfChanging"
                            v-model="selectedWay"
                            :custom-label="wayName"
                            :placeholder="wayName(selectedWay)"
                            :hide-selected="true"
                        )
                label.balance-modal__label
                    | {{ profile.name || profile.fullName }}
                    | ({{ balanceString }})
                template(v-if="selectedWay === 'manually'")
                    cs-input.balance-modal__input(
                        type="number"
                        step="0.01"
                        onkeydown.native="if (`${this.value}`.length >= 12 && event.keyCode !== 8) return false;"
                        :placeholder="$i18n.t('billing.billing_modal_inputPlaceholder')"
                        v-model.number="balance"
                        v-validate="'required|max:12'"
                        v-focus="true"
                        name="number"
                        :data-vv-as="$i18n.t('billing.billing_modal_balanceCount')"
                    )
                    help-text(v-if="errors.has('number')" :error="errors.has('number')")
                        | {{ errors.first('number') }}
                template(v-if="selectedWay === 'byAmountOfStudents'")
                    div(v-for="(accessValue, access) in profile.accesses")
                        template(v-if='accessValue')
                            label.balance-modal__label
                                | {{ $i18n.t('billing.billing_modal_amountOfStudents_' + access) }}
                            cs-input(
                                type="number"
                                onkeydown.native="if (`${this.value}`.length >= 12 && event.keyCode !== 8) return false;"
                                :placeholder="$i18n.t('billing.billing_modal_amountOfStudentsPlaceholder')"
                                v-model.number="amounts[access]"
                                v-validate="'required|max:12|min_value:0'"
                                :name="access"
                                :data-vv-as="$i18n.t('billing.billing_modal_amountOfStudents_' + access).toLowerCase()"
                            )
                            help-text(v-if="errors.has(access)" :error="errors.has(access)")
                                | {{ errors.first(access) }}
                    .balance-modal__buttons
                        cs-button.balance-modal__button(
                            color="blue"
                            type="button"
                            pattern="primary-outline"
                            :loading="isLoading"
                            :disabled="errors.has('number')"
                            @click="calculateSum(false)"
                        )
                            | {{ $i18n.t('billing.billing_modal_calculateSum') }}
                template(v-if="selectedWay === 'byAmountOfTeachers'")
                    label.balance-modal__label
                        | {{ $i18n.t('billing.billing_modal_amountOfTeachers') }}
                    cs-input(
                        type="number"
                        onkeydown.native="if (`${this.value}`.length >= 12 && event.keyCode !== 8) return false;"
                        :placeholder="$i18n.t('billing.billing_modal_amountOfStudentsPlaceholder')"
                        v-validate="'required|max:12|min_value:0'"
                        v-model.number="teachersAmount"
                        :name="'Учителя'"
                    )
                    .balance-modal__buttons
                        cs-button.balance-modal__button(
                            color="blue"
                            type="button"
                            pattern="primary-outline"
                            :loading="isLoading"
                            :disabled="errors.has('number')"
                            @click="calculateSum(true)"
                        )
                            | {{ $i18n.t('billing.billing_modal_calculateSum') }}
                template(v-if="authUser.isSuperadmin")
                    textarea.balance-modal__textarea(
                        v-validate="'required'"
                        v-model="comment"
                        :placeholder="$i18n.t('billing.billing_modal_commentPlaceholder')"
                        :data-vv-as="$i18n.t('billing.billing_modal_comment')"
                        name="text"
                    )
                    help-text(v-if="errors.has('text')" :error="errors.has('text')")
                        | {{ errors.first('text') }}
                div(v-if="isCalculationReady && selectedWay === 'byAmountOfStudents' || 'byAmountOfTeachers'")
                    | {{ infoAboutPayment }}
                .balance-modal__item.balance-modal__text--big
                    | {{ $i18n.t('miles.miles_modal_total') }} {{ total + " " + $i18n.tc('olympiads.olympiads_olympiadForm_rubles', total) }}
                label.balance-modal__label
                    | {{ infoText }}
                cs-checkbox(v-model="dataProcessing" v-if="!authUser.isSuperadmin")
                    span
                        | {{ $i18n.t('billing.billing_personalDataProcessAgreeStart') }}
                        |
                        a.balance-modal__link(href="http://cleverstart.ru/terms-of-use" target="_blank")
                            | {{ $i18n.t('billing.billing_offer') }}
                        |
                        | {{ $i18n.t('billing.billing_personalDataProcessAgreeEnd') }}
                .balance-modal__buttons
                    router-link.balance-modal__link(
                        v-if="authUser.isSuperadmin"
                        :to="{name: 'transactions:list', params: paramsForRequest}"
                    ) {{ $i18n.t('billing.billing_modal_billingChangingHistory') }}
                    cs-button.balance-modal__button(
                        color="blue"
                        type="submit"
                        :loading="isLoading"
                        :disabled="errors.has('number') || !balance || !dataProcessing"
                    ) {{ $i18n.t('billing.billing_modal_changeBalance') }}
        .balance-modal__result(v-else)
            span
                svg-icon.balance-modal__success(name="check", size="xx-large")
            span.balance-modal__text
                | {{ changedStatus }}
</template>

<script>
    /*eslint-disable*/
    import CsModal from '../elements/CsModal.vue';
    import AccountApi from '../api/billing/account';
    import modulBankPaymentMixin from "../utils/modulBankPaymentMixin";
    import { mapState } from 'vuex';

    export default {
        props: {
            profile: Object,
            type: {
                type: String,
                default: 'school'
            }
        },
        components: {
            CsModal
        },
        mixins: [modulBankPaymentMixin],
        data () {
            return {
                isLoading: false,
                balance: null,
                comment: null,
                waysOfChanging: ['manually'],
                selectedWay: 'manually',
                amounts: {
                    mentalArithmetic: null,
                    fastReading: null,
                    onlineSchool: null,
                    mathMagic: null,
                    memoryDevelopment: null,
                    multiplication: null,
                    readingEn: null,
                },
                teachersAmount: 0,
                isEnough: false,
                sum: 0,
                sumToPay: 0,
                remainsOnAccount: 0,
                isCalculationReady: false,
                dataProcessing: false,
                successChanged: false,
            }
        },
        mounted() {
            this.$validator.validateAll();
            this.dataProcessing = !!this.authUser.isSuperadmin;
        },
        methods: {
            updateBalance () {
                this.$validator.validateAll()
                .then(response => {
                    if (response && this.balance && this.dataProcessing) {
                        this.balance = Math.round(this.balance * 100) / 100;
                        if (this.balance < 0 && !this.authUser.isSuperadmin) {
                            this.$toasted.error(this.$i18n.t('billing.billing_only_positive_balance'));
                            return;
                        }
                        this.isLoading = true;
                        if (this.authUser.isSuperadmin) {
                            this.$emit('balance', +this.balance);
                        }
                        let schoolId = this.profile.type === 'student' ? this.profile.schools.find(school => school.studentPayed).id : undefined;
                        AccountApi.updateAccountBalance(
                            this.profile.account.id,
                            {
                                balance: this.balance,
                                comment: this.comment,
                                schoolId: schoolId
                            }
                        )
                        .then(data => {
                            if (!this.authUser.isSuperadmin) {
                                if (data.url.includes('https://pay.modulbank.ru/pay')) {
                                    this.redirectToModulBank(data.url);
                                } else {
                                    document.location = data.url;
                                }
                            }
                            this.isLoading = false;
                            this.successChanged = true;
                            setTimeout(() => {this.$emit('close');}, 5000)
                        })
                        .catch(err => {
                            this.isLoading = false;
                            this.$toasted.error(err.error)
                        });
                    }
                });
            },
            handleWayChange (way) {
                this.selectedWay = way;
            },
            calculateSum (forTeachers) {
                this.isLoading = true;
                this.isCalculationReady = false;
                this.balance = null;
                const accountId = this.profile.account.id;
                if (!forTeachers) {
                    this.validateAmountsOfStudentsFields()
                        .then(() => {
                            AccountApi.getSumToPay(accountId, {amounts: this.amounts})
                                .then(response => {
                                    this.getSumResponseHandler(response)
                                })
                                .catch(err => {
                                    this.getSumCatchHandler(err);
                                });
                        })
                        .catch(() => this.isLoading = false);
                } else {
                    AccountApi.getSumToPayForTeachers(accountId, {amount: this.teachersAmount})
                        .then(response => {
                            this.getSumResponseHandler(response)
                        })
                        .catch(err => {
                            this.getSumCatchHandler(err);
                        });
                }
            },
            getSumResponseHandler(response) {
                this.isEnough = response.isEnough;
                this.remainsOnAccount = response.remainsOnAccount;
                this.sum = response.sum;
                if (this.isEnough) {
                    this.sumToPay = 0;
                } else {
                    this.sumToPay = Math.abs(this.remainsOnAccount);
                    this.balance = this.sumToPay;
                }
                this.isLoading = false;
                this.isCalculationReady = true;
            },
            getSumCatchHandler(err) {
                this.$toasted.error(err);
                this.isLoading = false;
                this.isCalculationReady = false;
                this.balance = null;
            },
            validateAmountsOfStudentsFields () {
                return new Promise((resolve, reject) => {
                    Object.entries(this.profile.accesses).forEach(([access, accessValue]) => {
                        if (accessValue) {
                            this.$validator.validate(access).then(result => {
                                if (!result) {
                                    reject();
                                }
                                resolve();
                            });
                        }
                    });
                });
            },
            wayName (way) {
                return this.$i18n.t('billing.billing_balanceChanging_' + way);
            }
        },
        computed: {
            ...mapState({
                authUser: state => state.auth.user
            }),
            paramsForRequest () {
                let params = {};
                if (this.type === 'school') {
                    Object.assign(params, {accountId: this.profile.account.id, isStudentPayed: this.profile.studentPayed});
                } else {
                    Object.assign(params, {studentName: this.profile.fullName, isStudentPayed: true});
                }
                return params;
            },
            infoAboutPayment () {
                let string = this.$i18n.t('billing.billing_modal_resultSum', {sum: this.sum + " " + this.$i18n.tc('olympiads.olympiads_olympiadForm_rubles', this.sum)});
                string += " ";
                string += this.isEnough
                        ? this.$i18n.t('billing.billing_modal_enoughToPay', {remains: this.remainsOnAccount + " " + this.$i18n.tc('olympiads.olympiads_olympiadForm_rubles', this.remainsOnAccount)})
                        : this.$i18n.t('billing.billing_modal_notEnoughToPay', {sum: this.sumToPay + " " + this.$i18n.tc('olympiads.olympiads_olympiadForm_rubles', this.sumToPay)});
                return string;
            },
            balanceString () {
                return this.profile.account.balance + ' '
                        + this.$i18n.tc('olympiads.olympiads_olympiadForm_rubles', this.profile.account.balance);
            },
            total () {
                return Math.round((this.profile.account.balance + this.balance) * 100) / 100;
            },
            infoText () {
                if (!this.authUser.isSuperadmin) {
                    return this.$i18n.t('olympiads.olympiads_success_helpText') + this.$i18n.t('olympiads.olympiads_helpText_support') + this.$i18n.t('olympiads.olympiads_helpText_mail');
                }
                return "";
            },
            changedStatus () {
                if (this.balance > 0) {
                    return this.$i18n.t('billing.billing_modal_' + (this.authUser.isSuperadmin ? 'moneyWasAdded' : 'invoiceWasCreated'));
                } else {
                    return this.$i18n.t('billing.billing_modal_moneyWasRemoved');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .way-selector {
        display: flex;
        margin: 15px 0;
        @include media ($md) {
            margin: 15px 25px;
        }
        @include media ($xl) {
            margin: 15px 60px;
        }
    }

    .way-selector__buttons {
        display: none;
        @include media($md) {
            display: flex;
            width: 100%;
        }
    }

    .way-selector__multiselect {
        width: 100%;
        display: block;
        @include media($md) {
            display: none;
        }
    }

    .balance-modal__form {
        margin-top: 25px;
        text-align: left;
    }

    .balance-modal__input {
        margin-top: 10px;
        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button{
            appearance: none;
            margin: 0;
        }
    }

    .balance-modal__label {
        font-size: 16px;
        line-height: 19px;
        text-align: left;
        display: flex;
        margin: 10px 0;
    }


    .balance-modal__textarea {

        box-sizing: border-box;

        outline: none;

        color: $x-color-black;

        width: 100%;

        border-radius: $border-radius-5;
        border: 1px solid $hsl-color-gray-74;

        font-weight: normal;
        font-size: $font-size-16;
        line-height: $font-size-19;

        //@include inset-squish-space($space-small);

        padding: 12px 15px;

        @include stack-space($space-x-small);

        &:hover {
            border-color: $hsl-color-blue-56;
        }

        &:focus {
            border-color: $hsl-color-blue-56;
        }

        &:active {
            border-color: $hsl-color-blue-56;
        }

        &::placeholder {
            font-weight: lighter;
        }

        align-items: center;
        height: 2.25em;
        justify-content: flex-start;
        position: relative;
        vertical-align: top;
        background-color: #fff;
        box-shadow: inset 0 1px 2px hsla(0,0%,4%,.1);
        max-width: 100%;

        display: block;
        min-width: 100%;

        word-wrap: break-word;
        resize: none;
        max-height: 200px;
        min-height: 100px;

        overflow: hidden;
        overflow-wrap: break-word;
    }

    .balance-modal__buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
    }

    .balance-modal__item {
        margin-top: 10px;
    }

    .balance-modal__text {
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
    }

    .balance-modal__text--big {
        font-weight: 500;
        font-size: 18px;
        line-height: 21px;
    }

    .balance-modal__buttons {
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        @include media($md) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }

    .balance-modal__link {
        color: $hsl-color-blue-56;
        text-decoration: underline;
        margin-bottom: 20px;
        @include media($md) {
            margin-bottom: 0;
        }
    }

    .balance-modal__link:hover {
        color: $hsl-color-blue-56;
        text-decoration: none;
    }

    .balance-modal__button {
        max-width: 220px;
        @include media($md) {
            max-width: none;
        }
    }

    .balance-modal__result {
        display: flex;
        flex-direction: column;
    }

    .balance-modal__success {
        border-radius: 50%;
        color: $hsl-color-green-58;
        border: 4px solid $hsl-color-green-58;
        padding: 8px;
        margin-bottom: 20px;
    }


    .balance-modal__text {
        font-size: 22px;
        font-weight: 500;
    }

    .balance-modal__textarea {
        display: block;
        line-height: 1.25;
        max-height: 600px;
        max-width: 100%;
        min-height: 120px;
        min-width: 100%;
        padding: 0.625em;
        resize: vertical;
    }
</style>
